const initializeLocalStorage = (key = '') => {
  if (!localStorage.getItem('currentLocation')) {
    localStorage.setItem('currentLocation', JSON.stringify({}));
  }

  if (key) {
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, JSON.stringify({}));
    }
  }
};

export const addDataToLocalStorage = (data, itemKey, key) => {
  initializeLocalStorage(itemKey);

  try {
    const contributorsData = JSON.parse(localStorage.getItem(itemKey));
    if (contributorsData) {
      const newData = {
        [key]: data,
        created_at: Date.now(),
      };
      localStorage.setItem(itemKey, JSON.stringify(newData));
      return newData;
    }
  } catch (err) {
    return false;
  }
};

export const getItemFromLocalStorage = (itemKey, key) => {
  initializeLocalStorage();
  try {
    const data = JSON.parse(localStorage.getItem(itemKey));
    if (!oneDayAgo(data.created_at)) {
      return data[key];
    }

    return null;
  } catch (error) {
    return null;
  }
};

const oneDayAgo = (date) => {
  let oneDayAgo = new Date();
  oneDayAgo = oneDayAgo.setDate(oneDayAgo.getDate() - 1);
  const difference = date - oneDayAgo;
  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  if (daysDifference === 0) {
    return false;
  }
  return true;
};
